import React, { useEffect, useState } from 'react';
import MarkerClustererClass from '@google/markerclusterer';

export default function MarkerClusterer({ children, maps, map }) {
  const [cluster, setClusterer] = useState();

  useEffect(() => {
    const options = {
      imagePath:
        'https://joulepoint-customer.s3.ap-south-1.amazonaws.com/extras_static/m/m',
    };
    const cluster = new MarkerClustererClass(map, [], options);
    setClusterer(cluster);
  }, [map]);

  if (!cluster) return null;

  return React.Children.map(children, (child) => {
    return React.cloneElement(child, { map, maps, cluster });
  });
}
